import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BoardState {
  targetBoardName: string;
  targetBoardId: number | null;
}

const initialState: BoardState = {
  targetBoardName: "",
  targetBoardId: null,
};

const targetBoardNameSlice = createSlice({
  name: "boardName",
  initialState,
  reducers: {
    setBoardName: (state, action: PayloadAction<string>) => {
      state.targetBoardName = action.payload;
    },
    setBoardId: (state, action: PayloadAction<number>) => {
      state.targetBoardId = action.payload;
    },
  },
});

export const { setBoardName, setBoardId } = targetBoardNameSlice.actions;
export default targetBoardNameSlice.reducer;
